<template>
  <div>
    <a
      class="d-flex flex-column justify-content-center align-items-center card-action-button"
      :class="{ 'horizontal-button': horizontal }"
      @click="showModal()"
    >
      <div v-if="useSvgIcon" class="svg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" > <g id="_01_align_center" data-name="01 align center" > <path d="M21,2H18V0H16V2H8V0H6V2H3A3,3,0,0,0,0,5V24H24V5A3,3,0,0,0,21,2ZM2,5A1,1,0,0,1,3,4H21a1,1,0,0,1,1,1V8H2ZM2,22V10H22V22Z" /> <rect x="15" y="13" width="2" height="2" /> <rect x="11" y="13" width="2" height="2" /> <rect x="7" y="13" width="2" height="2" /> <rect x="15" y="17" width="2" height="2" /> <rect x="11" y="17" width="2" height="2" /> <rect x="7" y="17" width="2" height="2" /></g></svg>
      </div>
      <i v-else class="fa fa-calendar"></i>

      <span v-if="showText" class="card-action-text">VISITA</span>
    </a>
  </div>
</template>
<script>
import Modal from '../../classes/modal.class';

export default {
  name: "btn-richiedi-visita",
  props: {
    name: {
      type: String,
    },
    immobile: {
      required: true
    },
    sessionid: {
      required: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    useSvgIcon: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showModal () {
      const modal = new Modal({
        name: this.name,
        class: 'big-modal',
        padding: false,
        component: 'richiedi-visita',
        closeButton: true,
        callback: () => { this.$modal.hide(this.name); },
        bind: {
          immobile: this.immobile,
          sessionid: this.sessionid,
          source: 'listing'
        }
      });
      this.$root.pushModal(modal);
    }
  },
}
</script>

<style scoped lang="scss">
.card-action-button {
  width: 48px;
}

@media screen and (min-width: 768px) {
  .horizontal-button {
    display: flex;
    flex-direction: row !important;
    justify-content: space-around !important;
    align-items: center;
    width: auto !important;
    padding: 0 15px;

    .card-action-text {
      font-size: 14px;
      padding: 0 0 0 5px;
      margin: 0;
    }
  }
}
</style>
